import { useState } from "react"

import Style from "./style"
import selectArrow from "./asset/select_arrow.svg"
import check from "./asset/check.svg"
import checked from "./asset/checked.svg"

import DefaultModal from "shared/ui/DefaultModal"
import DefaultButton from "shared/ui/DefaultButton"
import { useEffect } from "react"

const SelectWithModal = ({ defaultIndex, title, optionList, defaultOption, inputRef }) => {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [checkedValue, setCheckedValue] = useState(defaultIndex)
    const [selectedValue, setSelectedValue] = useState(defaultOption)

    // 적용 이벤트
    const applyEvent = () => {
        setIsModalOpen(false)
        setSelectedValue(optionList[checkedValue].code)
        inputRef.current = optionList[checkedValue].code
    }

    // 수정 상태일 때 기본값 삽입
    useEffect(() => {
        if (defaultIndex !== null) {
            setSelectedValue(optionList[defaultIndex].code)
            inputRef.current = optionList[defaultIndex].code
        }
    }, [])

    return (
        <>
            {isModalOpen &&
                <DefaultModal title={title} closeEvent={() => setIsModalOpen(false)}>
                    <Style.InternationalList>
                        {optionList.map((elem, index) =>
                            <Style.InternationalElement key={index} onClick={() => setCheckedValue(index)} checked={index === checkedValue}>
                                <img src={index === checkedValue ? checked : check} />
                                <h3>{elem.nation}</h3>
                                <p>{elem.code}</p>
                            </Style.InternationalElement>
                        )}
                    </Style.InternationalList>
                    <DefaultButton clickEvent={applyEvent}>선택하기</DefaultButton>
                </DefaultModal>
            }

            <Style.Wrapper>
                <Style.Select onClick={() => setIsModalOpen(state => !state)}>
                    <p>{selectedValue}</p>
                    <img src={selectArrow} />
                </Style.Select>
            </Style.Wrapper>
        </>
    )
}

export default SelectWithModal